// PremiumPage.jsx
import React, { useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./css/PremiumPage.css";
import { LanguageContext } from "./LanguageContext";

const PremiumPage = () => {
  const { language, toggleLanguage, translations } = useContext(LanguageContext);
  const { search } = useLocation();
  const qs = new URLSearchParams(search);

  // course from URL (?course=personal-finance or ?course=investindo-nos-eua)
  const course = qs.get("course") || "personal-finance";

  const isPersonalFinance = course === "personal-finance";

  // Course-specific text config
  const courseConfig = isPersonalFinance
    ? {
        name:
          language === "pt"
            ? "Curso de Finanças Pessoais"
            : "Personal Finance Course",
        description:
          language === "pt"
            ? "Aprenda a controlar suas finanças, investir com inteligência e construir riqueza nos EUA."
            : "Learn to control your finances, invest wisely, and build wealth in the U.S.",
        premiumPrice: translations.premiumPrice,
        features:
          language === "pt"
            ? [
                "Acesso completo a todos os módulos (0-5)",
                "Aprenda no seu ritmo",
                "Até 4 meses de acesso à plataforma",
                "Download do conteúdo ao final do curso",
              ]
            : [
                "Full access to all modules (0-5)",
                "Learn at your own pace",
                "Up to 4 months of platform access",
                "Download content at course completion",
              ],
      }
    : {
        name:
          language === "pt"
            ? "Investindo nos EUA para Brasileiros"
            : "Investing in the US for Brazilians",
        description:
          language === "pt"
            ? "Guia completo em português para brasileiros que querem investir nos EUA com segurança."
            : "Complete Portuguese-language guide for Brazilians who want to invest safely in the U.S.",
        premiumPrice: "$49.99",
        features:
          language === "pt"
            ? [
                "24+ vídeo-aulas em português",
                "Contas, impostos, ETFs, REITs e bonds",
                "Projeto Capstone de 90 dias",
                "Acesso vitalício ao conteúdo",
              ]
            : [
                "24+ video lessons in Portuguese",
                "Accounts, taxes, ETFs, REITs and bonds",
                "90-day Capstone project",
                "Lifetime access to content",
              ],
      };

  const paymentUrl = isPersonalFinance
    ? "/payment"
    : "/payment-investindo-nos-eua";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="premium-page">
      {/* Language Selector */}
      <button className="language-button" onClick={toggleLanguage}>
        {language === "en" ? "🇧🇷 Português" : "🇺🇸 English"}
      </button>

      <div className="premium-container">
        {/* Course Title */}
        <h1 className="premium-title">{courseConfig.name}</h1>

        {/* Main Card */}
        <section className="premium-card">
          <p className="premium-description">{courseConfig.description}</p>

          {/* Price */}
          <div className="premium-price-box">
            <span className="premium-price-label">
              {language === "pt" ? "Valor:" : "Price:"}
            </span>
            <span className="premium-price">{courseConfig.premiumPrice}</span>
          </div>

          {/* Features */}
          <div className="premium-features">
            <h3>
              {language === "pt" ? "O que está incluso" : "What's included"}
            </h3>
            <ul>
              {courseConfig.features.map((feature, idx) => (
                <li key={idx}>
                  <span className="premium-check">✓</span>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA Button */}
          <Link to={paymentUrl} className="premium-cta-btn">
            {language === "pt" ? "Comprar agora" : "Buy now"}
          </Link>

          <p className="premium-guarantee">
            {language === "pt"
              ? "Compra segura. Se não fizer sentido para você, devolvemos seu dinheiro."
              : "Secure purchase. If it doesn't work for you, we'll refund your money."}
          </p>
        </section>

        {/* Support Section */}
        <section className="premium-support">
          <h2>
            {language === "pt" ? "Precisa de Ajuda?" : "Need Help?"}
          </h2>
          <p>
            {language === "pt"
              ? "Estamos aqui para te apoiar! Entre em contato por e-mail se precisar de ajuda."
              : "We're here to support you! Contact us via email if you need help."}
          </p>

          <div className="premium-support-grid">
            <div className="premium-support-item">
              <h4>{language === "pt" ? "Acesso ao curso" : "Course Access"}</h4>
              <p>
                {language === "pt"
                  ? "Precisa de mais tempo ou está com dificuldades na plataforma? Fale com a gente."
                  : "Need more time or having trouble on the platform? Talk to us."}
              </p>
            </div>
            <div className="premium-support-item">
              <h4>
                {language === "pt" ? "Programas de mentoria" : "Mentorship Programs"}
              </h4>
              <p>
                {language === "pt"
                  ? "Saiba mais sobre as sessões disponíveis e como participar."
                  : "Learn more about available sessions and how to join."}
              </p>
            </div>
          </div>

          <p className="premium-email">
            <strong>Email:</strong> investdecoded@investdecoded.com
          </p>
        </section>
      </div>
    </div>
  );
};

export default PremiumPage;
